export default "__VITE_ASSET__5d3db7a1__"